import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-gray-50 py-16 px-4 md:px-8" data-id="element-65">
      <div className="max-w-3xl mx-auto text-center" data-id="element-66">
        <div className="inline-block bg-white p-4 rounded-full shadow-lg mb-6" data-id="element-67">
          <ShieldCheck className="w-16 h-16 text-green-600" data-id="element-68" />
        </div>
        <h2 className="text-3xl font-black text-gray-900 mb-6" data-id="element-69">
          Garantía de Satisfacción Total
        </h2>
        <p className="text-xl text-gray-700 leading-relaxed" data-id="element-70">
          Probalo 7 días. Si no cumple tus expectativas, te devolvemos el 100%.{' '}
          <br data-id="element-71" />
          <span className="font-bold" data-id="element-72">Sin preguntas.</span>
        </p>
      </div>
    </section>;
}